import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import "./index.css";

// Yo'nalish manzilga qarab tanlanadi. React Router qo'shilmadi: ikki
// sahifa uchun yangi bog'liqlik (~10 KB + API) asoslanmagan.
//
// Backend `/{path:path}` ni `index.html` ga yo'naltiradi, shuning uchun
// `/dashboard` to'g'ridan-to'g'ri ochilganda ham ishlaydi.
const Page = window.location.pathname.startsWith("/dashboard") ? Dashboard : App;

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Page />
  </StrictMode>,
);
